import { useContext } from 'react';
import { DynamicContext } from './DynamicContext.js';

// This is external context hook which is exposed to customers
const useDynamicContext = () => {
    const context = useContext(DynamicContext);
    if (context === undefined) {
        throw new Error('useDynamicContext must be used within a DynamicContextProvider');
    }
    const { accountSwitchState, authMode, authToken, awaitingSignatureState, connectedWallets, getNameService, handleLogOut, handleUnlinkWallet, isAuthenticated, isFullyConnected, isVerificationInProgress, linkedWallets, loadingNetwork, loginWithEmail, multiWalletWidgetState, network, networkConfigurations, qrcodeUri, rpcProviders, sdkHasLoaded, secondaryWallets, setLogInWithEmail, setMultiWalletWidgetState, setNetwork, setPrimaryWallet, setShowAuthFlow, setShowDynamicUserProfile, setShowQrcodeModal, shadowDOMEnabled, showAuthFlow, showQrcodeModal, user, walletConnector, wallets, walletsByChain, walletsToConnectByChain, primaryWallet, setShowBridgeWidget, sendWagmiSettings, internalEvents, } = context;
    return {
        accountSwitchState,
        authMode,
        authToken,
        awaitingSignatureState,
        connectedWallets,
        getNameService,
        handleLogOut,
        handleUnlinkWallet,
        internalEvents,
        isAuthenticated,
        isFullyConnected,
        isVerificationInProgress,
        linkedWallets,
        loadingNetwork,
        loginWithEmail,
        multiWalletWidgetState,
        network,
        networkConfigurations,
        primaryWallet,
        qrcodeUri,
        rpcProviders,
        sdkHasLoaded,
        secondaryWallets,
        sendWagmiSettings,
        setLogInWithEmail,
        setMultiWalletWidgetState,
        setNetwork,
        setPrimaryWallet,
        setShowAuthFlow,
        setShowBridgeWidget,
        setShowDynamicUserProfile,
        setShowQrcodeModal,
        shadowDOMEnabled,
        showAuthFlow,
        showQrcodeModal,
        user,
        walletConnector,
        wallets,
        walletsByChain,
        walletsToConnectByChain,
    };
};

export { useDynamicContext };
